import React from 'react';
import { useState } from "react";
import MenuLineIcon from 'remixicon-react/MenuLineIcon';
import '../../style.css';

export default function MenuIconButton(props) {
    const [isHover, setIsHover] = useState(false);

    const wrapper ={
        width:40,
        height:40,
        borderRadius:'50%',
        backgroundColor: isHover ? 'rgba(240,240,240,0.3)' : 'transparent',
    };

    const icon = {
        fontSize:32,
        marginTop:4,
        marginLeft:4,
        color:'white'
      }

    const mouseEnter = () => {
        setIsHover(true);
    };

    const mouseLeave = () => {
        setIsHover(false);
    };
    
    return(
        <div 
            className="menuButton"
            style={Object.assign(wrapper,props.style)} 
            onClick={props.onSelect}
            onMouseEnter={mouseEnter}
            onMouseLeave={mouseLeave}
        >
            <MenuLineIcon id="menuIcon" style={icon} size="32px"></MenuLineIcon>

        </div>

    )
}